import React, { useState } from "react";
import { db } from "../firebase";
import { collection, addDoc } from "firebase/firestore";
import "../styles/ReviewForm.css";
import { Link } from "react-router-dom";
import reviewVideo from "../assets/hotel-review-bg.mp4";
import { useLocation } from "react-router-dom";

const ReviewForm = () => {
  const [ratings, setRatings] = useState({
    food: 0,
    service: 0,
    ambiance: 0,
    value: 0,
    overall: 0,
  });
  const [review, setReview] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const hotelName = queryParams.get("hotel") || "Centauria Lake Hotel";

  const handleRating = (type, value) => {
    setRatings({ ...ratings, [type]: value });
  };

  const [selectedMeals, setSelectedMeals] = useState([]);

  const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const isFormValid =
  Object.values(ratings).every((val) => val > 0) &&
  // review.trim() &&
  // name.trim() &&
  selectedMeals.length > 0 ;
  // isValidEmail(email);

  const mealOptionsList = [
  "Dinner Buffet",
  "Lunch Buffet",
  "Breakfast Buffet",
  "À la carte"
  ];

  const handleMealToggle = (option) => {
    setSelectedMeals((prev) =>
      prev.includes(option)
        ? prev.filter((o) => o !== option)
        : [...prev, option]
    );
  };

  const handleSubmit = async () => {
    try {
      await addDoc(collection(db, "hotelReviews"), {
        ...ratings,
        review,
        name,
        email,
        mealOptions: selectedMeals, 
        createdAt: new Date(),
        hotelName,
      });
     	alert("🍽️ Thanks for your feedback! Come dine with us again! 😊");
      setRatings({ food: 0, service: 0, ambiance: 0, value: 0, overall: 0 });
      setReview("");
      setName("");
      setEmail("");
      setSelectedMeals([]);
    } catch (error) {
      console.error("Error submitting review:", error);
      alert("Something went wrong. Please try again.");
    }
  };

  const renderStars = (type) =>
    Array.from({ length: 5 }, (_, i) => (
      <span
        key={i}
        className={i < ratings[type] ? "star filled" : "star"}
        onClick={() => handleRating(type, i + 1)}
      >
        ★
      </span>
    ));

    return (
    <div className="review-wrapper"
      style={{ backgroundImage: `url("/f.jpg")` }} >
      {/* Overlay */}
      <div className="review-overlay"></div>

      {/* Review Form */}
      <div className="review-container">
        <h2>Centuria Group of Hotels</h2>
        <hr />
        <h3>Please Provide Your Feedback</h3>

        <div className="meal-options">
          <p style={{ fontWeight: "bold", marginBottom: "5px" }}>Meal Options</p>
          <div className="meal-grid">
            {mealOptionsList.map((option, index) => (
              <label key={index} className="meal-option">
                <input
                  type="checkbox"
                  checked={selectedMeals.includes(option)}
                  onChange={() => handleMealToggle(option)}
                />
                {option}
              </label>
            ))}
        </div>

        {["food", "service", "ambiance", "value", "overall"].map((type) => (
          <div key={type} className="rating-row">
            <label>{type.charAt(0).toUpperCase() + type.slice(1)}</label>
            <div>{renderStars(type)}</div>
          </div>
        ))}

        <textarea
          placeholder="Customer Suggestion..."
          value={review}
          onChange={(e) => setReview(e.target.value)}
        />
        <input
          type="text"
          placeholder="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />

        {email && !isValidEmail(email) && (
          <p style={{ color: "red", fontSize: "13px", marginTop: "-8px" }}>
            Please enter a valid email address.
          </p>
        )}

        
        </div>
        <hr></hr>

        {isFormValid && (
          <button className="submit-btn" onClick={handleSubmit}>
            Submit Review
          </button>
        )}

        {/* <p style={{ textAlign: "center", marginTop: "10px" }}>
          <Link to="/admin-login" style={{ color: "gold" }}>
            View Admin Panel
          </Link>
        </p> */}
      </div>
    </div>
  );
};

export default ReviewForm;
